import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../../constants/Languages.js';
import ItemTree from '../ItemTree.js';

//import components
import PageHeaderRecord from './common/PageHeaderRecord.js';
import RecordHeader from './common/RecordHeader.js';
import RecordSectionDesc from './common/RecordSectionDesc.js';
import RecordSection from './common/RecordSection.js';
import ItemBreadcrumbs from '../ItemBreadcrumbs.js';
import ItemNavigation from '../ItemNavigation.js';

import { getTextMetadataDataTransformed } from '../../../scripts/TextMetadata.js';

const ItemRecord = ({ clang, history,
    showBackButton, type, radioType, authorCompany, mailingParts, sourceOrigin, televisionType,
    anthologyDescription, anthologyDescriptions, allTitles, belongingToSeries, resumptions,
    relatedFilesAndRecords, authors, collections, externalLinks, triggerInstitutions,
    producersAndFilmStudios, creationTime, id, bibliographicText, annotations, countries, headings,
    theater, premiereYear, coCreators, productionYear, title, author, editionYear, linkedFilesAndRecords, types,
    interviewParts, secondaryHeadings, premiere, publishingHouses, edition, locations, publicationYear,
    physicalDescription, contents, publicationLanguage, parent, chapterTitle, partTitle,
    allChapterTitles, pagesRange, publishingSeries, publishingSubseries, origin }) => {

    const originalTitle = allTitles ? allTitles.filter(title => title.type === 'original')[0] : false;
    const translationBase = allTitles ? allTitles.filter(title => title.type === 'translation-base')[0] : false;

    const baseTitle = allTitles ? allTitles.filter(titleItem => titleItem.type === 'base')[0] : false;
    const dedication = allTitles ? allTitles.filter(title => title.type === 'dedication')[0] : false;
    const incipit = baseTitle && allTitles ? allTitles.filter(title => title.type === 'incipit')[0] : false;
    const incipitTitle = !baseTitle && allTitles ? allTitles.filter(title => title.type === 'incipit')[0] : false;

    const partDedication = allChapterTitles ? allChapterTitles.filter(title => title.type === 'dedication') : false;

    const anthologyDescAll = anthologyDescription || (anthologyDescriptions && anthologyDescriptions.length) ?
        {
            'desc': {type: 'anthologyDesc', values: anthologyDescription},
            'items': anthologyDescriptions ? anthologyDescriptions.map(descItem =>
                [
                    {type: 'anthTypes', values: descItem.types},
                    {type: 'anthAuthors', values: descItem.authors},
                    {type: 'anthTranslators', values: descItem.translators},
                ]
            ) : false
        } : false;

    const newMailingParts = mailingParts && mailingParts.length ?
        {
            'items': mailingParts.map(descItem =>
                [
                    {type: 'mailSender', values: descItem.sender.authors.concat(descItem.sender.institutions)},
                    {type: 'mailAddressee', values: descItem.addressee.authors.concat(descItem.addressee.institutions)},
                    {type: 'mailDescription', values: [{label: descItem.description}]},
                ].filter(descItem => descItem.values.length)
            ).filter(descItem => descItem.length)
        } : false;

    const newInterviewParts = interviewParts && interviewParts.length ?
        {
            'items': interviewParts.map(descItem =>
                [
                    {type: 'interInterviewer', values: descItem.interviewer.authors.concat(descItem.interviewer.institutions)},
                    {type: 'interInterlocutor', values: descItem.interlocutor.authors.concat(descItem.interlocutor.institutions)},
                ].filter(descItem => descItem.values.length)
            ).filter(descItem => descItem.length)
        } : false;

    const groupArr = (arr) => {
        const newArr = [];

        arr.forEach(function(listItem) {
            if (newArr.filter(elem => elem.type === listItem.entityType).length < 1) {
                newArr.push({type: listItem.entityType, values: [listItem]});
            } else {
                newArr.map(elem => elem.type === listItem.entityType ?
                    {
                        ...elem,
                        values: elem.values.push(listItem)
                    } : elem);
            }
        });
        return newArr;
    };

    const detailsData = [
        {label: 'parent', val: parent},
        {label: 'headings', val: headings},
        {label: 'secondaryHeadings', val: secondaryHeadings},
        {label: 'types', val: type !== 'book' && type !== 'content'? types : false},
        {label: 'typesAndKind', val: type === 'content' ? types : false},
        {label: 'radioType', val: radioType},
        {label: 'televisionType', val: televisionType},
        {label: 'linkedFilesAndRecords', val: linkedFilesAndRecords ? groupArr(linkedFilesAndRecords) : false},
        {label: 'author', val: author},
        {label: 'authors', val: !authorCompany ? authors : false},
        {label: 'authorCompany', val: authorCompany ? authors : false},
        {label: 'title', val: baseTitle ? {...baseTitle, label: title} :  false},
        {label: 'incipitTitle', val: incipitTitle},
        {label: 'incipit', val: incipit},
        {label: 'publicationLanguage', val: publicationLanguage},
        {label: 'translationBase', val: translationBase},
        {label: 'translationBaseLang', val: translationBase ? translationBase.language : false},
        {label: 'titleOriginal', val: originalTitle},
        {label: 'titleOriginalLang', val: originalTitle ? originalTitle.language : false},
        {label: 'dedication', val: dedication ? dedication : false},
        {label: 'typesAndKind', val: type === 'book' ? types : false},
        {label: 'theater', val: theater},
        {label: 'premiereYear', val: premiereYear},
        {label: 'coCreators', val: coCreators ? coCreators.map(item => { return {label: item.label, values: item.people}}) : false},
        {label: 'partTitle', val: partTitle},
        {label: 'chapterTitle', val: chapterTitle},
        {label: 'partDedication', val: partDedication},
        {label: 'edition', val: edition},
        {label: 'premiere', val: premiere},
        {label: 'resumptions', val: resumptions},
        {label: 'countries', val: countries},
        {label: 'editionYear', val: editionYear},
        {label: 'productionYear', val: productionYear},
        {label: 'producersAndFilmStudios', val: producersAndFilmStudios},
        {label: 'triggerInstitutions', val: triggerInstitutions},
        {label: 'locations', val: locations},
        {label: 'publishingHouses', val: publishingHouses},
        {label: 'publicationYear', val: publicationYear},
        {label: 'physicalDescription', val: physicalDescription},
        {label: 'belongingpublishingSeries', val: publishingSeries || publishingSubseries ? {series: publishingSeries, subseries: publishingSubseries} : false},
        {label: 'belongingToSeries', val: belongingToSeries},
        {label: 'anthologyDesc', val: anthologyDescAll},
        {label: 'mailingParts', val: newMailingParts.items && newMailingParts.items.length ? newMailingParts : false},
        {label: 'interviewParts', val: newInterviewParts.items && newInterviewParts.items.length ? newInterviewParts : false},
        {label: 'sourceOrigin', val: sourceOrigin},
        {label: 'pagesRange', val: pagesRange},
        {label: 'annotations', val: getTextMetadataDataTransformed(annotations)},
        {label: 'contents', val: contents},
        {label: 'collections', val: collections},
    ].filter(dataItem => Array.isArray(dataItem.val) ? dataItem.val.length : dataItem.val);

    const externalLinksData = externalLinks && externalLinks.length ?
                                  externalLinks.map(link => {
                                      return {
                                          label: link.label,
                                          val: {
                                              label: link.link,
                                              link: link.link,
                                              desc: link.description
                                          }
                                      }
                                  })
                                  : false;

    const originData = origin && origin.length ?
                          origin.map(item =>
                              {
                                  return {
                                      label: item.entityType,
                                      val: item
                                  }
                              }
                          )
                          : false;

    const relatedFilesAndRecordsData = relatedFilesAndRecords && relatedFilesAndRecords.length ?
                                          [
                                            {
                                              label: 'relatedFilesAndRecords',
                                              val: groupArr(relatedFilesAndRecords).map(item =>
                                              {
                                                  return {
                                                      type: item.type,
                                                      values: item.values
                                                  }
                                              })
                                            }
                                          ]
                                          : false;

    const breadcrumbsList = [{label: 'home'}, {label: 'records', link: '/about-characteristics/records'}, {label: type, link: `/results?q=*&area=records&RECORD_FORM[0]=${type}`}];

    const recordName = title;

    return (
        <div className="record">
            <ItemBreadcrumbs list={breadcrumbsList} currentPage={recordName}/>

            <div className="record-container">
                <PageHeaderRecord name={lang[clang].item.types[type]} />
                <ItemNavigation history={history} showBackButton={showBackButton}/>
                <div className="record__content">
                    <RecordHeader name={lang[clang].item.types[type]} creationTime={creationTime} id={id}/>
                    <div className="record__sections">
                        {bibliographicText &&
                            <RecordSectionDesc label="bib_desc" text={bibliographicText} type={type}/>}
                        {detailsData.length &&
                            <RecordSection label="details" data={detailsData} type={type}/>}
                        {originData &&
                            <RecordSection label="provenance" data={originData} type={type}/>}
                        {externalLinksData &&
                            <RecordSection label="external_links" data={externalLinksData} type={type}/>}
                        {relatedFilesAndRecordsData &&
                            <RecordSection label="related_records" data={relatedFilesAndRecordsData} type={type}/>}
                    </div>
                </div>
            </div>
        </div>
    );
};

ItemRecord.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(ItemRecord);



// WEBPACK FOOTER //
// ./src/components/items/records/ItemRecord.js